import React,{ useState,useEffect } from "react"
import { Grid } from '@material-ui/core'
import Switch from '@material-ui/core/Switch';
import Hidden from '@material-ui/core/Hidden';

const animText = {
   fontSize: '16px',
   textAlign: 'right',display: 'block'
}
const Animationbtns = {
   marginTop: "30px",position: "relative",margin: "30px 0 14px 0"
}

const Animationbtns1 = {
   position: "relative",margin: "0 0 14px",marginBottom: "14px"
}

const animSpan = {
   display: 'inline-block',
   verticalAlign: 'middle',
   width: '57%',
   textAlign: 'right',
   paddingLeft: '15px',
   paddingRight: '10px'
}

const AnimationBtn = (props) => {

   return (
      <>
         <div id="animation" style={Animationbtns}>
            <span style={animSpan}>{window.finalLangues.reduceTransitions}: </span>
            {/* <Switch id="switchValue" onChange={displayName} name="checkedA" color="primary"/><span className = 'onOff'>{value}</span> */}
            <label className="switch" tabIndex="1" id="animswtich" onKeyPress={props.forKeypress} >
               <input tabIndex="-1" className="tabIndexStyle" name='animationOnOff' id="animSwitchValue" onChange={props.onchange} type="checkbox" />
               <span className="tabIndexStyle slider round" ></span>
               <span className="onOff"></span>
            </label>
         </div>
         {
            <div id="animation1" style={Animationbtns1} >
               <span style={animSpan}>{window.finalLangues.onScreenControls}: </span>
               {/* <Switch id="switchValue" onChange={displayName} name="checkedA" color="primary"/><span className = 'onOff'>{value}</span> */}
               <label className="switch" tabIndex="1" id="animswtich1" onKeyPress={props.forKeypress1} >
                  <input tabIndex="-1" className="tabIndexStyle" name='keyboadrControlsOnOff' id="animSwitchValue1" onChange={props.onchange1} type="checkbox" />
                  <span className="tabIndexStyle slider round" ></span>
                  <span className="onOff1"></span>
               </label>
            </div>
         }
         {/* { window.isipad || window.mob || window.innerWidth<800 ? null :
         <div className='microLogo'>
            <ul>
               <li className="microLogoList">
                   <img src="img/microsidebarlogo.png" alt='logo'/>
               </li>
               <li className="microLogoList text">
                 <p>Run business critical workloads in Azure, on-premises and at the edge. Windows Server 2022 delivers advanced 
                  multi-layer security, hybrid cloud capabilities with Azure, 
                  and a flexible application platform to modernize applications.
                  ​</p>
               </li>
            </ul>
         </div>
         } */}
         {/* <div className="animationoff" id="animation" style={{ ...Animationbtns,marginTop: '30px' }}>
            <Grid container style={{ alignItems: 'center' }}>
               <Grid item xs={8} id="animation">
                  <span style={animText}>{window.finalLangues.reduceTransitions}: </span>
               </Grid>
               <Grid item xs={4}>
                  <label className="switch" tabIndex="1" id="animswtich" onKeyPress={props.forKeypress} >
                     <input tabIndex="-1" className="tabIndexStyle" name='animationOnOff' id="animSwitchValue" onChange={props.onchange} type="checkbox" />
                     <span className="tabIndexStyle slider round"></span>
                     <span className="onOff"></span>
                  </label>
               </Grid>
            </Grid>
         </div>
         {!(window.mob) &&

            <div className="onscreencontrol" id="animation1" style={{ ...Animationbtns }}>
               <Grid container style={{ alignItems: 'center' }}>
                  <Grid item xs={8} id="animation1">
                     <span style={animText}>{window.finalLangues.onScreenControls}: </span>
                  </Grid>
                  <Grid item xs={4}>
                     <label className="switch" tabIndex="1" id="animswtich1" onKeyPress={props.forKeypress1} >
                        <input tabIndex="-1" className="tabIndexStyle" name='keyboadrControlsOnOff' id="animSwitchValue1" onChange={props.onchange1} type="checkbox" />
                        <span className="tabIndexStyle slider round" ></span>
                        <span className="onOff1"></span>
                     </label>
                  </Grid>
               </Grid>
            </div>
         } */}
          <div id="logoIntelDiv"  >
            <img id="dellTech" src="img/dellTech.png" alt="dellTechImg" />
         <img id="logoIntel" src="img/intel.svg" alt="intelImg"/>
     </div>

      </>
   )
}

export default AnimationBtn;